import { ColorEnum } from '@/constants/color'

export const animationDurationMs = 150

export const selectedContainerColor = {
    primary: ColorEnum.Blue50,
    destructive: ColorEnum.Brick100,
} as const

export const selectedBorderColor = {
    primary: ColorEnum.BLUE_500,
    destructive: ColorEnum.BRICK_600,
} as const

export const selectedNameColor = {
    primary: ColorEnum.Blue600,
    destructive: ColorEnum.BRICK_600,
} as const

export const selectedPriceColor = {
    primary: ColorEnum.BLUE_500,
    destructive: ColorEnum.BRICK_600,
} as const
